module.exports = {
      id: "quote-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.209f7259.svg#quote-usage",
      toString: function () {
        return this.url;
      }
    }